import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, Observable, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { routerSegments } from '@consts/routes';
import { ActiveOrganization } from '@models/organization.model';
import * as OrganizationSelectors from '@states/organization/organization.selectors';

import { AppState } from '../store/app.state';

export const cblEnabledGuard: CanActivateFn = () => {
  const router = inject(Router);
  const store$: Store<AppState> = inject(Store<AppState>);

  const selectActiveOrganization$: Observable<ActiveOrganization> = store$.select(
    OrganizationSelectors.selectActiveOrganization,
  );

  return selectActiveOrganization$.pipe(
    // The flag is only meaningful once the active organization has been loaded.
    filter((activeOrganization) => !!activeOrganization),
    take(1),
    map((activeOrganization) =>
      activeOrganization.cblEnabled ? true : router.createUrlTree([routerSegments.notFound]),
    ),
  );
};
